import React,{ useState,useContext } from 'react';
import { useStyles } from '../styles';
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Varieties from "./Varieties";
import Adons from "./AddOns";
import CookInstructions from './CookInstructions';
import Checkbox from "@mui/material/Checkbox";
import CurrencySymbol from './CurrencySymbol';
import Slider from "react-slick";
import { Store } from "../Store";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import CloseIcon from "@material-ui/icons/Close";
import {Box,Button,Card,CardActionArea,CardContent,CardMedia,DialogTitle,Grid,Slide,TextField,Typography,Dialog,IconButton,
} from "@material-ui/core";
import { getPriceWithIncrease } from '../Configs';

export default function OrderCustomize(props) {
  const styles = useStyles();
  let t= props.t;
  const { state, dispatch } = useContext(Store);
  let {customizeInWizard} = state;
  console.log(props.orderItem);
  let prodAdOnCats= props.categories.filter(cat => props.orderItem.add_ons.indexOf(cat.id) != -1)
  const [customInstr, setCustomInstr] = useState("");
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  let isEditOrdItem = props.orderItems.filter(om=> om.id== props.orderItem.id).length;
  let minTtlAdon=0;
  function getMinAdon(total, cat) {
  return total + (cat.hasOwnProperty("minAddOnAllowed")?cat.minAddOnAllowed:1);
}
  minTtlAdon=prodAdOnCats.reduce(getMinAdon,0);
  console.log('minTotal',minTtlAdon);
  
  const handleCookInstr = (instr) => {
    let prod = { ...props.orderItem, sub_pro: { ...props.orderItem.sub_pro, cookInstructions: [...props.orderItem.sub_pro.cookInstructions] } };
    let ciIndx = -1; 
    prod.sub_pro.cookInstructions.filter((ci, i) => {return ci == instr?ciIndx=i:false});
    console.log(ciIndx);
    if(ciIndx != -1){
      prod.sub_pro.cookInstructions.splice(ciIndx,1);
    }else{
      prod.sub_pro.cookInstructions.push(instr);
    }
    console.log(prod);
    props.setOrderItem(prod);
  };

  const onAdOnItemSelectChange = (AoI, isRemove) => {
    console.log(AoI);
    let prod = { ...props.orderItem, sub_pro: { ...props.orderItem.sub_pro, addons: [...props.orderItem.sub_pro.addons] } };
    let AoIndx = -1; 
    prod.sub_pro.addons.map((ao, i) => {return ao.id == AoI.id?AoIndx=i:false});
    console.log(AoIndx);
    if(AoIndx != -1){
      prod.sub_pro.addons.splice(AoIndx,1);
    }else if((AoIndx == -1) && !isRemove) {
      prod.sub_pro.addons.push(AoI);
    }
    console.log(prod);
    props.setOrderItem(prod);
  }
var settings = {
    dots: customizeInWizard?true:false,
    infinite: false,
    speed: 500,
    slidesToShow: customizeInWizard?1:prodAdOnCats.length+2,
    slidesToScroll: 1,
    swipeToSlide: true,
    lazyLoad:customizeInWizard?true:false,
    vertical:customizeInWizard?false:true
  };
 const handleVarieties = (varNm,varPrc) => {
    let prod = { ...props.orderItem, sub_pro: { ...props.orderItem.sub_pro, variety: {} } };
    prod.sub_pro.variety[varNm]= varPrc;
    props.setOrderItem(prod);
  }

  let { userInfo } = state.userData;

  const themeColor = userInfo?.themeColor || '#ffbc01';  
  const themeTxtColor = userInfo?.themeTxtColor || '#000'; 

  const galleryImages = Array.from(new Set([
    props.orderItem.image,
    ...(props.orderItem.itemImgCollection || [])
  ])).filter(Boolean);
  
  return (
    <Box className="custom_window" style={{ position: "relative", backgroundColor: themeTxtColor, display: "flex", flexDirection: "column", height: "100%" }}>
      <IconButton 
        onClick={() => { isEditOrdItem ? props.removeOrderItm() : props.setIsCustomizeOpen(false) }}
        style={{ position: "absolute", top: 10, right: 10, zIndex: 1000, color: themeColor, backgroundColor: "rgba(0,0,0,0.05)" }}
      >
        <CloseIcon />
      </IconButton>
      <Box style={{ flex: 1, overflowY: "auto", overflowX: "hidden", paddingBottom: "10px", minHeight: 0 }}>
      <Slider {...settings}>
       <div id="titorder" className={customizeInWizard?styles.center:styles.centerAutoFit}  data-index={0}>

          <Card
            className={styles.cardd}
            id="card-img"
            style={{
              width: "auto",
              height: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "10px",
              border: "1px solid " + themeColor,
              borderRadius: "15px",
              padding: "10px",
              overflow: "hidden"
            }}
          >
            <Box style={{ width: "100%", height: "200px", borderRadius: "12px", overflow: "hidden", position: "relative" }}>
              <CardMedia
                component="img"
                alt={props.orderItem.name}
                image={props.orderItem.image}
                onError={props.imageOnErrorHandler}
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  backgroundColor: "#fff"
                }}
              />
              {galleryImages.length > 1 && (
                <IconButton 
                  onClick={() => setIsGalleryOpen(true)}
                  style={{ position: "absolute", bottom: 5, right: 5, backgroundColor: "rgba(0,0,0,0.5)", color: "#fff", zIndex: 10, padding: 8 }}
                >
                  <PhotoLibraryIcon />
                </IconButton>
              )}
            </Box>
            <Box style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              paddingTop: "15px",
              width: "100%"
            }}>
              <h4 style={{ margin: "5px 0" }}>{props.orderItem.name}</h4>
              <span style={{ padding: "5px 0", fontSize: "0.9rem", color: "rgba(0,0,0,0.7)" }}>
                {props.orderItem.description}
              </span>
              <h4 style={{ margin: "5px 0" }}>
                <CurrencySymbol />
                <span> {getPriceWithIncrease(props.orderItem.basePrice || props.orderItem.price, props.orderItem.onlineIncreaseBy || 0)}</span>
              </h4>
            </Box>
          </Card>
           
            <div id="btnorder" className={[styles.countRow, styles.center]}>
         {false&&<h2 ><i style={{color:themeTxtColor}}>{props.t({ id: "choose_your_quantity" })}</i></h2>}
            <Button
              className={styles.minus}
              id="minus_btn"
              variant="contained"
              color="primary"
              disabled={props.quantity === 1}
              onClick={(e) => props.quantity > 1 && props.setQuantity(props.quantity - 1)}
            >
              <RemoveIcon />
            </Button>
            <TextField
              inputProps={{ className: styles.largeInput }}
              InputProps={{
                bar: true,
                inputProps: {
                  className: styles.largeInput,
                  style: { color: themeColor }
                },
              }}
              className="largeNumber"
              type="number"
              variant="filled"
              min={1}
              value={props.quantity}
              style={{ color: themeColor}}
            />

            <Button
              className={styles.add}
              id="plus_btn"
              variant="contained"
              style={{ color: "#fff" }}
              onClick={(e) => props.setQuantity(props.quantity + 1)}
            >
              <AddIcon sx={{ fontSize: "1px" }} style={{ color: "#fff" }} />
            </Button>
          </div>
        
         <Varieties 
          varieties= {props.orderItem.varietyPrices} 
          t={t}
          orderItem = {props.orderItem}
          handleVarieties= {handleVarieties}
          userInfo={userInfo}
          />
          </div>
            
          {prodAdOnCats.map((cat, i) => 
          {
            return <div className={customizeInWizard?styles.center:styles.centerAutoFit} >
          <Adons cat={cat} 
            onSelectionChange={onAdOnItemSelectChange} 
            items={props.items}
            orderItem = {props.orderItem}
             t={t}
             baseURL={props.baseURL}
             customizeInWizard={customizeInWizard}
             imageOnErrorHandler={props.imageOnErrorHandler}/>
           </div>} )}
          
          <CookInstructions t={props.t} 
          cookInst={props.orderItem.cookInstructions} 
          orderItem = {props.orderItem}
          t={t}
          customInstr={customInstr}
          setCustomInstr={setCustomInstr}
          handleCookInstr={handleCookInstr}
          minTtlAdon={minTtlAdon}
          customizeInWizard={customizeInWizard}/>

        </Slider>
        </Box>

        <Box id="footorder" className={[styles.row, styles.around]} style={{ padding: "10px", borderTop: "1px solid #ccc", background: themeTxtColor, position: "sticky", bottom: 0, zIndex: 1000 }}>
          <Button
            onClick={()=>{isEditOrdItem?props.removeOrderItm(): props.setIsCustomizeOpen(false)}}
            variant="text"
            size="large"
            id="btcancel"
            style={{
              padding: "6px 22px!important",
              color: themeColor,
              textDecoration: "underline"
            }}
          >
            {isEditOrdItem? t({ id: "remove" }):t({ id: "cancel" })}
          </Button>

          <Button
            onClick={()=>props.addToOrderHandler(customInstr)}
            size="large"
            variant="outlined"
            id="btcart"
            style={{
              padding: "6px 22px!important",
              border: '2px solid ' + themeColor,
              borderRadius: "32px",
              color: themeColor
            }}
            disabled={(minTtlAdon > props.orderItem['sub_pro']['addons'].length)}
          >
            {isEditOrdItem? t({ id: "update" }):t({ id: "add" })}
          </Button>
        </Box>

      <Dialog open={isGalleryOpen} onClose={() => setIsGalleryOpen(false)} maxWidth="sm" fullWidth PaperProps={{ style: { backgroundColor: '#000', margin: 10, width: 'calc(100% - 20px)' } }}>
        <Box style={{ position: "relative", backgroundColor: "#000", paddingBottom: "20px" }}>
          <IconButton onClick={() => setIsGalleryOpen(false)} style={{ position: "absolute", top: 5, right: 5, color: "#fff", zIndex: 10 }}>
            <CloseIcon />
          </IconButton>
          <Slider dots={true} infinite={true} speed={500} slidesToShow={1} slidesToScroll={1} arrows={false}>
            {galleryImages.map((img, idx) => (
              <div key={idx} style={{ height: "400px", textAlign: "center", paddingTop: "40px", outline: "none" }}>
                <img src={img} style={{ maxWidth: "100%", maxHeight: "350px", objectFit: "contain", margin: "0 auto" }} onError={props.imageOnErrorHandler} alt={`Gallery ${idx}`} />
              </div>
            ))}
          </Slider>
        </Box>
      </Dialog>
    </Box>
  );
}
